import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-micro-itfacility-closur',
  templateUrl: './micro-itfacility-closur.component.html',
  styleUrls: ['./micro-itfacility-closur.component.scss']
})
export class MicroItfacilityClosurComponent implements OnInit {
public ITcloserData:any=[];
public employeeId:any=[];
public Itcloserdata1:any=[];
  constructor(public appservice:AppService,public toastr:ToastrService,public router:Router) { }
getemployeeif(){
  this.appservice.getTable("api/Transaction/GetMicrosoftItfacility_empid").subscribe((res:any)=>{
  this.employeeId=JSON.parse(res).record;

  })
}


Onselectempolyee() {
  const empId = this.ITcloserData.employeeid;
  if (!empId) {
    console.warn("Employee ID is missing");
    return;
  }

  this.appservice.getTable(`api/Transaction/GetmicrosoftItfacility_closer?empid=${empId}`)
    .subscribe({
      next: (res: any) => {
        // If your API already returns JSON, no need to parse
        const data = JSON.parse(res).record[0];
        
        if (!data) {
          console.warn("No employee data found");
          return;
        }

        // Populate ITcloserData
        this.ITcloserData = {
          ...this.ITcloserData,
          MD_EmployeeId: data.MD_EmployeeId,
          MD_Fullname: data.MD_Fullname,
          MD_ADUserName: data.MD_ADUserName,
          MD_ADMailId: data.MD_ADMailId,
          MD_Designation: data.MD_Designation,
          MD_Grade: data.MD_Grade,
          MD_Department: data.MD_Department,
          MD_Micsoftdynamic360: data.MD_Micsoftdynamic360,
          MD_company_name: data.MD_company_name,
          MD_UserId: data.MD_UserId,
          MSimcard: data.IR_Mobilesim,
          MD_RoleCenter: data.MD_RoleCenter,
          MD_Previlage_Access: data.MD_Previlage_Access,
          MD_Approval_Access:data.MD_Approval_Access,
          MD_ReporterName:data.MD_ReporterName
        };

        console.log("Employee selected:", this.ITcloserData.Fullname);
      },
      error: (err) => {
        console.error("Error fetching employee details:", err);
      }
    });
}


onDecline(){
  this.ITcloserData.status='Rejected';
  this.ITcloserData.approvedby=this.appservice.username;
    this.appservice.getTable("api/Transaction/update_Microsoftitfacilitycloser?empid="+this.ITcloserData.MD_EmployeeId+"&status="+this.ITcloserData.status+"&username="+this.ITcloserData.approvedby).subscribe((res:any)=>{
  this.toastr.success("Rejected successfully!");
   // this.appservice.getcheckerITfacilitygrid();
    this.getemployeeif();
    });
    this.appservice.goback();
  //this.router.navigate(['/home/checkerreview'])
}


back(){
  this.appservice.goback();
}
onApprove(){
  this.ITcloserData.status='Approved';
  this.ITcloserData.approvedby=this.appservice.username;
   this.appservice.getTable("api/Transaction/update_Microsoftitfacilitycloser?empid="+this.ITcloserData.MD_EmployeeId+"&status="+this.ITcloserData.status+"&username="+this.ITcloserData.approvedby).subscribe((res:any)=>{
    this.toastr.success("Approved successfully!");
   // this.appservice.getcheckerITfacilitygrid();
    this.getemployeeif();
   });
  //this.appservice.checkeritfacilityedit='';
  //this.router.navigate(['/home/checkerreview'])
  this.appservice.goback();
}
  ngOnInit(): void {
    this.getemployeeif();
  }

}
